export default __webpack_public_path__ + "static/media/ghosh.f6f508f3.jpg";